// extracted by mini-css-extract-plugin
export default {"quick-view":"QuickView_quick-view__L4HVh","close-icon":"QuickView_close-icon__9x0yd"};